import DataTable from 'react-data-table-component';
import styles from "./styles";
import React, {useState} from "react";
import PropTypes from "prop-types";
import userModel from "../../../../assets/data/user";
import azure from "../../../../utils/azure";
import Api from "../../../../Api/Api";
import Button from "@mui/material/Button";
import dayjs from "dayjs";
import Icon from "@mui/material/Icon";
import colors from "../../../../colors";
import language from "../../../../assets/data/language";
import UploadModal from "./uploadModal";
import GenerateCard from "./generateCard";
import Notification from "./notifications"
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import RenderCert from "../../../../components/Certificate"
import { useUserController } from "../../../../context/user";
import { qr } from "../../../../constants";

const ExpandedComponent = ({data}) => {
  return <div style={styles.expandable}>

  </div>;
}

ExpandedComponent.propTypes = {
  data: PropTypes.object.isRequired
};

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  maxWidth: '98%',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  li: {
    listStyleType: 'decimal'
  },
  h2: {
    textAlign: 'center'
  }
};

function Certificates({user, spanish}) {
  const [userData, setUserData] = useState(false);
  const [quizzes, setQuizzes] = useState(false);
  const [adminRegen, setAdminRegen] = useState(false);
  const [otherUploadQuiz, setOtherUploadQuiz] = useState(false);
  const [otherUploadQuizSource, setOtherUploadQuizSource] = useState(false);
  const [uploadQuiz, setUploadQuiz] = useState('');
  const [regen, setRegen] = useState(false);
  const [uploadIssued, setUploadIssued] = useState('');
  const [uploadExpiration, setUploadExpiration] = useState('');
  const [certUploader, setCertUploader] = useState(false);
  const [fileMessage, setFileMsg] = useState(false);
  const [cardGenerated, setGenerateCard] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const {fetchCertificates} = azure;
  const fetchControl = React.useRef(false);
  const fetchControlQuiz = React.useRef(false);
  const [userController, userDispatch] = useUserController();

  const fetchQuizData = async () => {
    const quizData = await Api.getAllQuizzes().then(quizData => quizData.data).catch(err =>console.log(err))
    setQuizzes(quizData)
    return quizData;
  }

  if(!quizzes && !fetchControlQuiz.current) {
    fetchControlQuiz.current = true;
    fetchQuizData()
  }

  const getExpiration = (row) => {
    try {
      if(row.expiration) return row.expiration
      else {
        const quiz = quizzes.filter(q => q.id === row.certificate?.metadata?.quiz);
        if(quiz[0]) {
          const taken = new Date(row.date);
          let yearsToAdd;
          let frequency = quiz[0].quizFrequency;
          if(frequency === "Annual") yearsToAdd = 1;
          else if(frequency === "ThreeYears") yearsToAdd = 3;
          else yearsToAdd = 2;
          const expiration = dayjs(taken.setFullYear(taken.getFullYear() + yearsToAdd)).format('MM/DD/YYYY');
          return expiration
        } else return ""
      }
    } catch (e) {
      return ""
    }

  }
  // const getCertificates = async () => {
  //   fetchControl.current = true;
  //
  //   const certificatesUser = await fetchCertificates(user.UserID).then(certs => certs).catch(err => console.log(err));
  //   const certificatesEmail = await fetchCertificates(user.Email).then(certs => certs).catch(err => console.log(err));
  //   let certificates = [ ...certificatesUser]
  //   if(Array.isArray(certificatesEmail)) certificates = [...certificates, ...certificatesEmail]
  //   const oldest = {}
  //   const latestToKeep = {}
  //   let rows = certificates.map(certificate => {
  //     let count = certificate.name.split("-").length - 1;
  //     let name = certificate.name.split("/")[1];
  //     if(count > 1) name = certificate.name.split("/")[1]
  //     const row = {
  //       name,
  //       path: certificate.name,
  //       quiz: certificate.metadata.quizName || certificate.metadata.quizname || certificate.metadata.videoName || certificate.metadata.videoname,
  //       date: certificate.metadata.issued ? certificate.metadata.issued : "",
  //       expiration: certificate.metadata.expiration ? certificate.metadata.expiration : "",
  //       certificate,
  //     }
  //     if (oldest[row.quiz]) oldest[row.quiz].push(certificate.metadata.issued)
  //     else oldest[row.quiz] = [certificate.metadata.issued]
  //     return row
  //   })
  //   for(let k in Object.keys(oldest)) {
  //     let tag = Object.keys(oldest)[k];
  //     const oldestDate = oldest[tag].sort((a, b) => new Date(a) - new Date(b))[oldest[tag].length - 1];
  //     latestToKeep[tag] = oldestDate;
  //   }
  //   rows = rows.filter(a => {
  //     if(!latestToKeep[a.quiz] || latestToKeep[a.quiz] === a.date) return a;
  //   })
  //   setUserData(rows)
  // }
// Drop-in replacement with detailed timings
  const getCertificates = async () => {
    const now = () =>
      (typeof performance !== "undefined" && performance.now)
        ? performance.now()
        : Date.now();

    const t = { start: now() };
    const timings = {};

    // small helper to time any async call and return both value + ms
    const timeAsync = async (label, fn) => {
      const s = now();
      try {
        const value = await fn();
        const ms = now() - s;
        timings[label] = ms;
        return { status: "fulfilled", value, ms };
      } catch (err) {
        console.error(`${label} failed:`, err);
        const ms = now() - s;
        timings[label] = ms;
        return { status: "rejected", value: [], ms, err };
      }
    };

    fetchControl.current = true;

    // --- Fetch in parallel and time each one ---
    const fetchAllStart = now();
    const [byUser, byEmail] = await Promise.all([
      timeAsync("fetch_userId", () => fetchCertificates(user.UserID)),
      timeAsync("fetch_email", () => fetchCertificates(user.Email)),
    ]);
    timings.fetch_parallel_overhead = now() - fetchAllStart;

    // Merge results
    const mergeStart = now();
    const certificatesUser = Array.isArray(byUser.value) ? byUser.value : [];
    const certificatesEmail = Array.isArray(byEmail.value) ? byEmail.value : [];
    let certificates = [...certificatesUser, ...certificatesEmail];
    timings.merge = now() - mergeStart;

    // Map to rows + collect per-quiz dates
    const mapStart = now();
    const oldest = {}; // actually "allDatesByQuiz"
    let rows = certificates.map((certificate) => {
      const nameFromPath = (certificate?.name || "").split("/")[1] || certificate?.name || "";
      const md = certificate?.metadata || {};
      const quiz =
        md.quizName || md.quizname || md.videoName || md.videoname || "";
      const date = md.issued || "";
      const expiration = md.expiration || "";

      if (quiz) {
        (oldest[quiz] ||= []).push(date);
      }

      return {
        name: nameFromPath,
        path: certificate?.name,
        quiz,
        date,
        expiration,
        certificate,
      };
    });
    timings.map = now() - mapStart;

    // Compute latest date to keep per quiz
    const reduceStart = now();
    const latestToKeep = Object.fromEntries(
      Object.entries(oldest).map(([quiz, dates]) => {
        const latest =
          dates
            .filter(Boolean)
            .sort((a, b) => new Date(a) - new Date(b))
            .at(-1) || "";
        return [quiz, latest];
      })
    );
    timings.reduce = now() - reduceStart;

    // Keep only latest per quiz (or all if no latest known)
    const filterStart = now();
    rows = rows.filter((r) => !latestToKeep[r.quiz] || latestToKeep[r.quiz] === r.date);
    timings.filter = now() - filterStart;

    // Set state
    const setStateStart = now();
    setUserData(rows);
    timings.set_state = now() - setStateStart;

    timings.total = now() - t.start;

    // Pretty print results
    // console.table({
    //   fetch_userId: Math.round(timings.fetch_userId ?? 0),
    //   fetch_email: Math.round(timings.fetch_email ?? 0),
    //   fetch_parallel_overhead: Math.round(timings.fetch_parallel_overhead ?? 0),
    //   merge: Math.round(timings.merge ?? 0),
    //   map: Math.round(timings.map ?? 0),
    //   reduce: Math.round(timings.reduce ?? 0),
    //   filter: Math.round(timings.filter ?? 0),
    //   set_state: Math.round(timings.set_state ?? 0),
    //   total: Math.round(timings.total ?? 0),
    // });
  };

  if (!userData && !fetchControl.current) getCertificates()

  const closeModal = (e) => {
    setUploadIssued('');
    setUploadQuiz('');
    setCertUploader(false);
    setOtherUploadQuiz(false);
    setUploadExpiration(false);
    setOtherUploadQuizSource(false);
  }

  const uploadCert = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && ["application/pdf", "image/jpeg", "image/png"].includes(file.type)) {
      if (file.size > 1500000) setFileMsg(language.common.fileLarge(spanish));
      else {
        let quiz = quizzes.filter(q => q.id === uploadQuiz);
        let file_name = quiz[0]?.english?.title || otherUploadQuizSource || file.name;
        let expiration =  uploadExpiration ? dayjs(uploadExpiration).format('MM/DD/YYYY') : "";
        if(quiz[0]?.quizFrequency && expiration === "")  {
          let freq = {
            "Annual": 1,
            "TwoYears": 2,
            "ThreeYears": 3
          }
          expiration = dayjs(uploadIssued).add(freq[quiz[0]?.quizFrequency], 'year').format('MM/DD/YYYY')
        }
        const meta = {
          quiz: uploadQuiz || "",
          issued: dayjs(uploadIssued).format('MM/DD/YYYY'),
          expiration: expiration,
          quizname: quiz[0]?.english?.title || otherUploadQuizSource
        }
        // console.log(meta, quiz, "META")
        azure.uploadCert(file, `${user.UserID}/${file_name}`, meta).then(saved => {
          setUserData(false);
          fetchControl.current = false;
          setCertUploader(false);
          getCertificates();

        }).catch(err => console.log(err));
      }
    } else setFileMsg(language.certificates.fileWrong(spanish))
  }

  const deleteCert = async (e, file) => {
    await azure.deleteCert(file.certificate.name).then(deleted => console.log(deleted)).catch(err => console.log(err));
    await getCertificates();
  }

  const recreateCert = async (e, file, adminRecreate=false) => {
    if(adminRecreate) {
      let expiration;
      const dt = "08/11/2025"
      if(file.quizFrequency)  {
        let freq = {
          "Annual": 1,
          "TwoYears": 2,
          "ThreeYears": 3
        }
        expiration = dayjs(dt).add(freq[file.quizFrequency], 'year').format('MM/DD/YYYY')
      }
      file = {
        "name": file.english.title,
        "path": user.UserID,
        "quiz": file.english.title,
        "date": dt,
        "expiration": expiration,
        certificate: {
          "name": file.english.title,
          "metadata": {
            "expiration": expiration,
            "issued": dt,
            "quiz": file.id,
            "quizname": file.english.title
          }
      }
    }
    }
    setRegen(file)
    // await azure.deleteCert(file.certificate.name).then(deleted => console.log(deleted)).catch(err => console.log(err));
    // await getCertificates();
  }



  const columns = [
    {
      name: language.certificates.name(spanish),
      selector: row => row.name,
      sortable: true,
      grow: 2,
      minWidth: "320px",
      wrap: true
    },
    {
      name: language.certificates.issued(spanish),
      // selector: row => row.date,
      id: 'date',                    // unique column ID
      cell: row => new Date(row.date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
      }),
      selector: row => Date.parse(row.date),
      sortable: true
    },
    {
      name: language.certificates.expiration(spanish),
      selector: row => getExpiration(row),
      sortable: true
    },
    {
      name: language.certificates.quiz(spanish),
      selector: row => row.quiz,
      sortable: true
    },
    {
      name: language.certificates.manual(spanish),
      selector: row => row.certificate.manualUpload ? language.common.yes(spanish) : language.common.no(spanish),
      sortable: true
    },
    {
      name: language.certificates.regen(spanish),
      selector: row => <button
        style={{...styles.btn, backgroundColor: "transparent", color: colors[process.env.REACT_APP_APP_INSTANCE].primary}}
        onClick={(e) => recreateCert(e, row)}
      ><Icon fontSize="medium">replay</Icon></button>,
      hide:  !["Admin", "Admin+"].includes(userController.user.Admin)
    },
    {
      name: language.certificates.download(spanish),
      selector: row => <button
        style={{...styles.btn, backgroundColor: "transparent", color: colors[process.env.REACT_APP_APP_INSTANCE].primary}}
        onClick={async (e) => {
          e.preventDefault();
          console.log(row, "ROW")
          // window.open(row.certificate.url, "_blank");
          try {
            const response = await fetch(row.certificate.url, { mode: "cors" });
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", row.name || row.quiz);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
          } catch (error) {
            console.error("Download failed:", error);
          }
        }}
      ><Icon fontSize="medium">download</Icon></button>
    },
    {
      name: language.certificates.delete(spanish),
      selector: row => <button
        style={{...styles.btn, backgroundColor: "transparent", color: colors[process.env.REACT_APP_APP_INSTANCE].primary}}
        onClick={(e) => deleteCert(e, row)}
      >
        <Icon fontSize="medium">delete</Icon>
      </button>
    }
  ];


  const filteredItems = (userData && filterText != "") ? userData.filter(
    item => {
      const enabled = ['name', 'date']
      const possible_rows = Object.keys(item);
      let toReturn = false;
      for (let row in possible_rows) {
        const key = possible_rows[row]
        if (enabled.includes(key)) {
          let value = item[key]
          if (['CompanyID', 'JobClassification'].includes(key)) {
            let model = userModel.companyId;
            if (key == "JobClassification") model = userModel.classification;
            value = model[value - 1]
          }
          if (value && value !== null && value.toString().toLowerCase().includes(filterText.toLowerCase())) toReturn = item;
        }
      }
      return toReturn
    }
  ) : userData;


  const regenFromDB = async (e) => {
    const adminQz = [];

    // Fetch logs
    const logs = await Api.getVideoLog(user.UserID, 'all').then(res => {
      console.log(res);
      return res.data;
    });

    // Get all quizzes in parallel using Promise.all
    const quizPromises = Object.keys(logs).map(async (item) => {
      const qres = await Api.getOneQuiz(item);
      if (qres.data && qres.data.length > 0) {
        adminQz.push(qres.data[0]);
      }
    });

    // Wait for all getOneQuiz calls to finish
    await Promise.all(quizPromises);

    // Now update state after all data is ready
    console.log(adminQz, "QUIZ")
    setAdminRegen(adminQz);
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText('');
      }
    };
    return (
      <div style={styles.toolbar}>
        <input
          style={{
            transition: 'box-shadow 0.2s ease 0s',
            padding: 8,
            border: '1px solid rgba(0, 22, 66, 0.32)',
            background: 'rgb(246, 249, 250)',
            outline: 'none',
            borderRadius: 2
          }}
          autoComplete="off"
          placeholder={language.common.search(spanish)}
          onChange={e => setFilterText(e.target.value)}
          value={filterText}/>
        {userController.user.id === 1670 && <Button variant={"contained"} onClick={regenFromDB}>Regen From DB</Button>}
        {["Admin", "Admin+"].includes(userController.user.Admin) && <Button variant={"contained"} onClick={(e) => {
          // fetchQuizData()
          setCertUploader(true);
        }}>{language.common.upload(spanish)}</Button>}


      </div>


    );
  }, [filterText, resetPaginationToggle]);

  const handleUploadQuiz = (e) => {
    const value = e.target.value;
    if(value === "clear"){
      setOtherUploadQuiz(false);
      setOtherUploadQuizSource("");
      setUploadQuiz("");
    } else if(value !== "Other") {
      if(otherUploadQuiz) {
        setOtherUploadQuiz(false);
        setOtherUploadQuizSource("");
      }
      setUploadQuiz(e.target.value)
    }
    else setOtherUploadQuiz(true)

  }
  const generateCard = (e) => {
    // console.log("generates")
    setGenerateCard(true);
  }

  let visibleColumns = columns.filter(col => !col.hide);

  return (
    <div style={styles.container}>
      <UploadModal
        certUploader={certUploader}
        closeModal={closeModal}
        spanish={spanish}
        handleUploadQuiz={handleUploadQuiz}
        quizzes={quizzes}
        otherUploadQuiz={otherUploadQuiz}
        otherUploadQuizSource={otherUploadQuizSource}
        setOtherUploadQuizSource={setOtherUploadQuizSource}
        fileMessage={fileMessage}
        uploadCert={uploadCert}
        uploadQuiz={uploadQuiz}
        uploadIssued={uploadIssued}
        setUploadIssued={setUploadIssued}
        setUploadExpiration={setUploadExpiration}
        uploadExpiration={uploadExpiration}
      />
      {adminRegen && <Modal
        open={adminRegen}
        onClose={() => setAdminRegen(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        color="primary"
      >
        <Box sx={{
          ...style,
          width: 600,
          minHeight: 300,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: 'center'
        }}>
          {adminRegen.map((aQ, i) => <div key={i}>
            <p>{aQ.english.title}
              <button
                style={{
                  ...styles.btn,
                  backgroundColor: "transparent",
                  color: colors[process.env.REACT_APP_APP_INSTANCE].primary,
                }}
                onClick={(e) => recreateCert(e, aQ, true)}
              ><Icon fontSize="medium">replay</Icon></button>
            </p>
          </div>)}
        </Box>

      </Modal>}
      {regen && <Modal
        open={regen}
        onClose={() => {
          setRegen(false);
          setUserData(false);
          fetchControl.current = false;
          getCertificates();
        }}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        color="primary"
      >
        <Box sx={{
          ...style,
          width: 600,
          minHeight: 300,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignContent: 'center'
        }}>
          <RenderCert data={regen} spanish={spanish} regenerate={true} urlToUpdate={regen.certificate.url} user={user}/>
        </Box>
      </Modal>}
      {userData ?  <div style={{width: "100%", overflowX: "auto"}}>
        <DataTable
          title={language.certificates.certificates(spanish)}
          columns={visibleColumns}
          data={filteredItems}
          // expandableRows
          // selectableRows
          pagination
          defaultSortFieldId="date"
          defaultSortAsc={false}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          highlightOnHover
          pointerOnHover
          expandableRowsComponent={ExpandedComponent}
        />
      </div> : '...loading'}
      {(userData && userData.length > 0) && <Button
        onClick={generateCard}
        variant="contained"
        style={{marginTop: 20}}
      >
        {language.certificates.generate(spanish)}
      </Button>}
      <GenerateCard
        spanish={spanish}
        user={user}
        quizzes={quizzes}
        closeModal={e => setGenerateCard(false)}
        modalOpen={cardGenerated}
        userData={userData}
      />
      <Notification
        userData={userData}
        spanish={spanish}
        quizzes={quizzes}
        user={user}
      />
    </div>

  );
}

Certificates.propTypes = {
  user: PropTypes.object,
  spanish: PropTypes.bool,
}

export default Certificates;
